import { memo } from 'react';
import dynamic from 'next/dynamic';
import { I_Scene } from '@containers/Home/types';
import { ThemeBaseKrpanoWrapper } from './styled';

const Tour = dynamic(() => import('@containers/Home/components/Tour'), {
  ssr: false,
});
const Controlbar = dynamic(() => import('./Controlbar'), { ssr: false });
const SideToolbar = dynamic(() => import('./SideToolbar'));
const PostScene = dynamic(() => import('./PostScene'));
const Copyright = dynamic(() => import('./Copyright'));
const Header = dynamic(() => import('./Header'));

interface Props {
  onNextScene: () => void;
  onChangeScene: (scene: I_Scene) => void;
}

export const ThemeBaseKrpano = memo(({ onChangeScene, onNextScene }: Props) => {
  return (
    <ThemeBaseKrpanoWrapper>
      <Header />
      <Tour onChangeScene={onChangeScene} onNextScene={onNextScene}>
        <Controlbar onChangeScene={onChangeScene} />
        <SideToolbar />
      </Tour>

      <PostScene />

      <Copyright />
    </ThemeBaseKrpanoWrapper>
  );
});

export default ThemeBaseKrpano;
